import {TimePicker, type TimePickerProps} from '@mantine/dates'
import {Time} from '@package/shared'
import {useCallback} from 'react'
import {useUserSettings} from '../../providers/userSettings/useUserSettings.ts'

type Props = Omit<TimePickerProps, 'value' | 'defaultValue' | 'onChange'> & {
  value?: Time | undefined
  onChange: (time: Time | undefined) => void
}

export const CustomTimePicker = ({onChange, ...rest}: Props) => {
  const {userSettings} = useUserSettings()

  const handleChange = useCallback(
    (value: string) => {
      const [hour, minute] = value.split(':')
      onChange(Time.safeParse(`${hour}:${minute}`).data)
    },
    [onChange],
  )

  return <TimePicker format={userSettings.timeFormat} {...rest} onChange={handleChange} />
}
